<script setup lang="ts">
import './style.css'

const props = defineProps<{ data?: string }>()

const router = useRouter()

onMounted(() => {
  document.querySelectorAll('a').forEach((link) => {
    const href = link.getAttribute('href')

    if (href && href.startsWith('/')) {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        router.push(href)
      })
    }
  })
})
</script>

<template>
  <article v-if="props.data" v-hydrated-html="props.data" class="content" />
  <article v-else class="content">
    <slot />
  </article>
</template>
